<template>
  <v-row v-if="enabled">
    <v-col>
      <h3>Eixos para análise de processos de pagamento</h3>
      <p>Esta autorização é independente das permissões de municípios e eixos abaixo.</p>
      <app-axis-by-project-combobox
        :filter="selection"
        name="Eixos permitidos para processos de pagamento"
      />
    </v-col>
  </v-row>
</template>

<script>
import { AppAxisByProjectCombobox } from "@/modules/axis";
import { groupsPermissionAPI } from "@/modules/groups/API/groupsPermissionAPI";
import { permissionAPI } from "./PermissionAPI";

export default {
  components: { AppAxisByProjectCombobox },
  props: {
    groupId: { type: Number, default: 0 },
    value: { type: Array, default: () => [] },
  },
  data() {
    return { groupPermissions: null, selection: { eixo: [] } };
  },
  computed: {
    enabled() {
      const group = this.groupPermissions || {};
      return (
        group.processosPagamentos &&
        group.podeAnalisarProcessoPagamento &&
        group.podeAnalisarProcessoPagamentoPorEixo
      );
    },
  },
  watch: {
    "selection.eixo"(axes) {
      this.$emit("change", axes || []);
    },
    groupId: {
      immediate: true,
      handler(groupId) {
        this.groupPermissions = null;
        if (!groupId) return;
        groupsPermissionAPI
          .getByGroup(groupId)
          .then(({ data }) => {
            if (Number(this.groupId) === Number(groupId)) this.groupPermissions = data;
          })
          .catch(() => {
            this.groupPermissions = null;
          });
      },
    },
    value: {
      immediate: true,
      handler(value) {
        this.selection.eixo = value || [];
      },
    },
  },
  mounted() {
    permissionAPI.list().then(({ data }) => {
      const special = data.find(
        (item) => item.nome === "AnaliseProcessoPagamentoPorEixo"
      );
      this.$emit("permission", special || null);
    });
  },
};
</script>
